<template>
  <footer class="app-footer">
    <div class="container footer-main">
      <div class="footer-brand">
        <h3>{{ config.web_company_name || 'Uni Link International Freight' }}</h3>
        <p>{{ config.web_site_description || '' }}</p>
        <div class="contact-line" v-if="config.tel">
          <i class="el-icon-phone"></i>
          <span>Tel: {{ config.tel }}</span>
        </div>
        <div class="contact-line" v-if="config.time">
          <i class="el-icon-time"></i>
          <span>Service Time: {{ config.time }}</span>
        </div>
        <div class="contact-line" v-if="config.web_site_email">
          <i class="el-icon-message"></i>
          <span>Email: {{ config.web_site_email }}</span>
        </div>
        <div class="contact-line" v-if="config.whatsapp">
          <i class="el-icon-chat-dot-round"></i>
          <span>WhatsApp: {{ config.whatsapp }}</span>
        </div>
        <div class="contact-line" v-if="config.web_site_address">
          <i class="el-icon-location-outline"></i>
          <span>Address: {{ config.web_site_address }}</span>
        </div>
      </div>

      <div class="footer-links">
        <div class="link-group">
          <h4>Quick Links</h4>
          <router-link to="/freight-calculator">Freight Quote</router-link>
          <router-link to="/tracking">Shipment Tracking</router-link>
        </div>
        <div class="link-group">
          <h4>About</h4>
          <router-link to="/about">About Us</router-link>
          <router-link to="/news">News & Updates</router-link>
          <a class="footer-link" @click="openPolicy('law')">Laws & Regulations</a>
        </div>
        <div class="link-group">
          <h4>Contact Us</h4>
          <router-link to="/message">Message Us</router-link>
          <a class="footer-link" @click="openPolicy('privacy')">Privacy Policy</a>
        </div>
        <div class="link-group" v-if="timeZones.length">
          <h4>Local Time</h4>
          <div class="tz-line" v-for="tz in timeZones" :key="tz.zone">
            <span class="tz-name">{{ formatZone(tz.zone) }}</span>
            <span class="tz-time">{{ getZoneTime(tz.zone) }}</span>
          </div>
        </div>
      </div>
    </div>

    <policy-dialog :visible.sync="showPolicy" :type="policyType" />

    <!-- <div class="footer-bottom">
      <div class="container">
        <div class="cert-row">
          <span><i class="el-icon-s-check"></i> Beijing Public Security Network Record No.: 11010102005444</span>
          <span>京ICP备2024Beijing ICP Registration No. 2021027275-1/ICP72775号-1</span>
          <span>Telecom Business License: Jing B2-20220608</span>
        </div>
        <div class="license-row">
          <span>Online Culture Business License: [Certificate Name]</span>
          <span>|</span>
          <span>Business License</span>
        </div>
        <p class="copyright">Copyright © 2022 Uni Link International Freight. All Rights Reserved.</p>
      </div>
    </div> -->
  </footer>
</template>

<script>
import PolicyDialog from '@/components/PolicyDialog.vue'
import { getSystemConfig } from '@/api/index'

export default {
  name: 'AppFooter',
  components: { PolicyDialog },
  data() {
    return {
      showPolicy: false,
      policyType: 'law',
      // 公司信息默认值（接口未返回时兜底展示）
      config: {
        web_company_name: '宁波优链国际物流有限公司',
        web_site_description: '智慧运输行业解决方案',
        tel: '400-123-1234',
        time: '',
        web_site_email: '',
        whatsapp: '',
        web_site_address: '浙江省宁波市鄞州区中河街道四明东路556号515-2室'
      },
      timeZones: [],
      // 实时时钟基准（毫秒时间戳），由定时器每秒刷新
      now: Date.now(),
      timer: null
    }
  },
  created() {
    this.fetchConfig()
  },
  beforeDestroy() {
    this.stopClock()
  },
  methods: {
    // 打开协议弹窗：law=Laws & Regulations(aid=3)，privacy=Privacy Policy(aid=2)
    openPolicy(type) {
      this.policyType = type
      this.showPolicy = true
    },

    // 获取系统配置
    // 兼容两种返回结构：
    //  1) 嵌套结构 { data: { sys: [...], time_zone: { 时区: { datetime } } } }
    //  2) 扁平结构   { data: [ { title, name, value } ] }
    async fetchConfig() {
      try {
        const res = await getSystemConfig({ code: 'tel,web_site_address,web_company_name,web_site_description,web_site_email,time,whatsapp' })
        if (res.code != '1' || !res.data) return
        const data = res.data
        const sysList = Array.isArray(data) ? data : (data.sys || [])
        const map = {}
        // 按接口返回的 name 字段映射（title 中文兜底）
        const TITLE_MAP = {
          '客服电话': 'tel',
          '客服服务时间': 'time',
          '公司名称': 'web_company_name',
          '公司地址': 'web_site_address',
          '站点描述': 'web_site_description',
          '邮箱': 'web_site_email',
          'WhatsApp': 'whatsapp'
        }
        sysList.forEach(item => {
          const key = item.name || TITLE_MAP[item.title] || ''
          // 仅当接口有值时才覆盖默认值
          if (key && item.value) map[key] = item.value
        })
        this.config = { ...this.config, ...map }
        // time_zone：对象转数组便于 v-for 展示（仅取 IANA 时区名，时间由前端实时计算）
        const tz = data.time_zone || {}
        this.timeZones = Object.keys(tz).map(zone => ({ zone }))
        this.startClock()
      } catch (e) {
        console.error('getSystemConfig failed', e)
      }
    },
    // 启动实时时钟：每秒刷新基准时间
    startClock() {
      this.stopClock()
      this.now = Date.now()
      this.timer = setInterval(() => {
        this.now = Date.now()
      }, 1000)
    },
    // 停止时钟，避免内存泄漏
    stopClock() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    // 按 IANA 时区名实时计算当前时间，格式 YYYY-MM-DD HH:mm:ss
    getZoneTime(zone) {
      if (!zone) return ''
      try {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: zone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).formatToParts(new Date(this.now))
        const map = {}
        parts.forEach(p => { map[p.type] = p.value })
        return `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}:${map.second}`
      } catch (e) {
        return ''
      }
    },
    // 时区名格式化：America/New_York -> New York
    formatZone(zone) {
      const parts = (zone || '').split('/')
      const last = parts[parts.length - 1] || zone
      return last.replace(/_/g, ' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  background: #1a2356;
  color: #fff;
}

.footer-main {
  display: flex;
  justify-content: space-between;
  padding: 60px 20px;
  gap: 60px;
}

.footer-brand {
  max-width: 360px;

  h3 {
    font-size: 18px;
    margin-bottom: 16px;
  }

  p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 20px;
    line-height: 1.8;
  }

  .contact-line {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 10px;

    i {
      color: #409eff;
    }
  }
}

.footer-links {
  display: flex;
  gap: 80px;
}

.link-group {
  display: flex;
  flex-direction: column;
  gap: 12px;

  h4 {
    font-size: 15px;
    margin-bottom: 8px;
    color: #fff;
  }

  a {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;

    &:hover {
      color: #fff;
    }
  }
}

.tz-line {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;

  .tz-name {
    font-weight: 600;
    color: #fff;
  }

  .tz-time {
    font-variant-numeric: tabular-nums;
  }
}

.footer-bottom {
  background: #12173d;
  padding: 24px 0;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);

  .cert-row {
    display: flex;
    justify-content: center;
    gap: 24px;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }

  .license-row {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-bottom: 10px;
  }

  .copyright {
    margin-top: 8px;
  }
}

@media (max-width: 768px) {
  .footer-main {
    flex-direction: column;
    gap: 30px;
  }

  .footer-links {
    gap: 30px;
    flex-wrap: wrap;
  }
}
</style>
